import { get } from "../../http/instance";

/**
 * Get tagihan pelanggan by kode_pelanggan
 * @param {string} kode_pelanggan - Nomor sambung pelanggan
 * @returns {Promise} Response dari API
 */
export const getTagihanPelanggan = async (kode_pelanggan) => {
    const response = await get('/public/service/tagihan-pelanggan', {
        params: {
            kode_pelanggan: kode_pelanggan
        }
    });
    return response;
}

/**
 * Get detail tagihan by id_bill_invoice (Public API)
 * @param {string} id_bill_invoice - ID bill invoice
 * @returns {Promise} Response dari API
 */
export const getDetailTagihanPublic = async (id_bill_invoice) => {
    const response = await get(`/public/service/detail-tagihan/${id_bill_invoice}`);
    return response;
}

